// extracted by mini-css-extract-plugin
export default {"btn_back":"button_btn_back__bqoNg","button_text":"button_button_text__9xNnw"};